import { Directive, TemplateRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[featureContainerSlot]'
})
export class FeatureContainerDirective {
  constructor(public tpl: TemplateRef<any>) {}
}

@Directive({
  standalone: true,
  selector: '[featureIcon]'
})
export class FeatureIconDirective {
  constructor(public tpl: TemplateRef<any>) {}
}

@Directive({
  standalone: true,
  selector: '[featureTitle]'
})
export class FeatureTitleDirective {
  constructor(public tpl: TemplateRef<any>) {}
}

@Directive({
  standalone: true,
  selector: '[featureIntro]'
})
export class FeatureIntroDirective {
  constructor(public tpl: TemplateRef<any>) {}
}

@Directive({
  standalone: true,
  selector: '[featureBody]'
})
export class FeatureBodyDirective {
  constructor(public tpl: TemplateRef<any>) {}
}

@Directive({
  standalone: true,
  selector: '[featureFooter]'
})
export class FeatureFooterDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
